import { render, staticRenderFns } from "./DownloadableFile.vue?vue&type=template&id=03ae7be8&"
import script from "./DownloadableFile.vue?vue&type=script&lang=ts&"
export * from "./DownloadableFile.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadableFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_dc55b0b5/src/components/button/Circle.vue').default})
